module.exports = __webpack_public_path__ + "img/frame (177).5df3796e.jpg";